import marketImage from '../assets/images/openMarket1.svg'
import { motion } from "framer-motion";

const OpenMarket = () => {

    const animation = (delay, xStart, xEnd, yStart, yEnd) => {
        const result = {
            initial: { opacity: 0, x: xStart, y: yStart },
            whileInView: { opacity: 1, x: xEnd, y: yEnd },
            viewport: { once: true },
            transition: {
                ease: "easeInOut",
                duration: 0.6,
                delay: delay,
            }
        }
        return result;
    }

    return (
        <>
            <div className='absolute -z-10 w-full h-full' style={{ width: '-webkit-fill-available' }}>
                <img src={marketImage} className='w-full h-full object-cover' alt="Market background" />
            </div>
            <div className='px-[5%] flex mt-[35%] flex-row max-sm:flex-col max-sm:mt-[45%] justify-center items-center'>
                <motion.div 
                    {...animation(0.3, 0, 0, 0, 0)} 
                    className='market_text text-center max-sm:max-w-[90%] max-sm:text-xl relative z-10'
                >
                    Powered by Abstract, MondrianSwap redefines liquidity. Shape the market, dictate the flow, and seize control in a new era of DeFi.
                </motion.div>
            </div>
        </>
    );
};
export default OpenMarket;
